"use client"

import { createContext, useContext, useState, useEffect, type ReactNode } from "react"
import { type Language, getTranslation } from "../lib/i18n"

type LanguageContextType = {
  lang: Language
  setLang: (lang: Language) => void
  translation: ReturnType<typeof getTranslation>
  isRTL: boolean
}

const LanguageContext = createContext<LanguageContextType | null>(null)

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Language>("en")
  const translation = getTranslation(lang)
  const isRTL = lang === "ar"

  useEffect(() => {
    document.documentElement.lang = lang
    document.documentElement.dir = isRTL ? "rtl" : "ltr"
  }, [lang, isRTL])

  return <LanguageContext.Provider value={{ lang, setLang, translation, isRTL }}>{children}</LanguageContext.Provider>
}

export function useLanguage() {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider")
  }
  return context
}
